import React from 'react';
import RseeDashboard from './rseeAdmin/rseeAdminDashboard';
import CafeDashboard from './cafeAdmin/cafeAdminDashboard';
import ShowForPermission from '../../components/ShowForPermission';
import ENUMS from '../../enums';

const Dashboard = props => {
  return (
    <>
      <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_ADMIN_DASHBOARD_REPORTS}>
        <RseeDashboard />
      </ShowForPermission>
      <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_CAFE_ADMIN_DASHBOARD_REPORTS}>
        <CafeDashboard />
      </ShowForPermission>
    </>
  );
};

export default Dashboard;
